/**
 * The version of the obchodní podmínky a customer accepts. Bump both values
 * whenever the Czech text changes in substance; the page and the sign-up
 * acceptance read them from here. Accounts are never asked to accept again
 * because the version changed: TermsGate only checks that some version was
 * accepted (needsTermsAcceptance), and changes reach existing customers by
 * notice under čl. 16.
 */
export const TERMS_VERSION = "2.0.1";

/** The day this version was published: it applies to new contracts from then. */
export const TERMS_PUBLISHED_DATE = "2026-10-25";

/** The day this version takes effect for customers who signed up earlier (ISO date). */
export const TERMS_EFFECTIVE_DATE = "2026-11-15";

export type TermsAcceptance = {
  terms_version: string;
  terms_accepted_at: string;
};

/**
 * What to store when someone accepts the terms, e.g. as user metadata:
 * `supabase.auth.signUp({ email, password, options: { data: termsAcceptance() } })`.
 */
export function termsAcceptance(now: Date = new Date()): TermsAcceptance {
  return { terms_version: TERMS_VERSION, terms_accepted_at: now.toISOString() };
}
